<template>
    <div class="selectedOrderContainer">
        <div class="orderId">
            <span class="orderZehot"> הזמנה</span> <span class="orderIdStyle">{{ $root.selectedOrderObj.ID }}</span>
            <br>
            <span class="orderIdStyle"> התקבלה בתאריך  {{ $root.selectedOrderObj.Data.createdDate }}  </span>
            <span class="orderIdStyle" style="color:#1c1c1c; font-weight: 500;"> |  הונפקה על ידי   {{ $root.selectedOrderObj.Data.workerName }} </span>
            
        </div>
        <div class="orderDataBox borders" v-if="editOrder">
            <div class="boxHeader">
                <span class="orderName">{{ $root.selectedOrderObj.Data.fullname }}</span>
                <button @click="deleteOrder($root.selectedOrderObj.ID)" class="deleteBtn"><span class="material-icons">delete_outline</span> </button>
                <button class="editBtn" @click="editOrder = !editOrder"><span class="material-icons">edit</span></button>
                <span class="selectedOrderPrice">{{$root.selectedOrderObj.Data.priceOrder}} ₪</span>
            </div>

            <div class="orderInputField">
                <label for="fullname">שם מלא</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.fullname" disabled >
            </div>
            <div class="orderInputField">
                <label for="phoneNumber">מספר הטלפון</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.phoneNumber" disabled>
            </div>
            <div class="orderInputField">
                <label for="dateOrder">תאריך</label><br>
                <input type="date" v-model="$root.selectedOrderObj.Data.dateOrder" disabled>
            </div>
            <div class="orderInputField">
                <label for="dayOrder">יום</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.dayOrder" disabled>
            </div>
            <div class="orderInputField">
                <label for="timeOrder">שעה</label><br>
                <input type="time" v-model="$root.selectedOrderObj.Data.timeOrder" disabled>
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">טעם העוגה</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.cakeTaste" disabled>
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">גודל העוגה</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.cakeSize" disabled>
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">מחיר ההזמנה</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.priceOrder" disabled>
            </div>
        </div>

        <div class="orderDataBox borders" v-else>
            <div class="boxHeader">
                <span class="orderName">{{ $root.selectedOrderObj.Data.fullname }}</span>
                <button @click="deleteOrder($root.selectedOrderObj.ID)" class="deleteBtn"><span class="material-icons">delete_outline</span> </button>
                <button class="editBtn" @click="editOrder = !editOrder"><span class="material-icons">edit</span></button>
                <span class="selectedOrderPrice">{{$root.selectedOrderObj.Data.priceOrder}} ₪</span>

            </div>

            <div class="orderInputField">
                <label for="fullname">שם מלא</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.fullname"  >
            </div>
            <div class="orderInputField">
                <label for="phoneNumber">מספר הטלפון</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.phoneNumber" >
            </div>
            <div class="orderInputField">
                <label for="dateOrder">תאריך</label><br>
                <input type="date" v-model="$root.selectedOrderObj.Data.dateOrder" >
            </div>
            <div class="orderInputField">
                <label>יום האספקה</label>
                <select v-model="$root.selectedOrderObj.Data.dayOrder"  >
                <option value="ראשון">ראשון</option>
                <option value="שני ">שני</option>
                <option value="שלישי">שלישי</option>
                <option value="רביעי">רביעי</option>
                <option value="חמישי">חמישי </option>
                <option value="שישי">שישי</option>
                <option value="שבת">שבת</option>
                </select>
            </div>
            <div class="orderInputField">
                <label for="timeOrder">שעה</label><br>
                <input type="time" v-model="$root.selectedOrderObj.Data.timeOrder" >
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">טעם העוגה</label><br>
                <select v-model="$root.selectedOrderObj.Data.cakeTaste" >
                    <option value="נסיך">נסיך</option>
                    <option value="ריבת חלב">ריבת חלב</option>
                    <option value="מוס שוקוניל">מוס שוקוניל</option>
                    <option value="רוגינצי">רוגינצי</option>
                    <option value="גפוניז">גפוניז</option>
                </select>
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">גודל העוגה</label><br>
                <select v-model="$root.selectedOrderObj.Data.cakeSize" >
                    <option value="3.5 פסים">3.5 פסים</option>
                    <option value="5 פסים">5 פסים</option>
                    <option value="עגולה">עגולה</option>
                </select>
            </div>
            <div class="orderInputField">
                <label for="cakeTaste">מחיר ההזמנה</label><br>
                <input type="text" v-model="$root.selectedOrderObj.Data.priceOrder" >
            </div>
            <div class="orderBtnField">
                <button @click="updateOrderData">שמור שינויים</button>
            </div>
        
        </div>
        <div class="ordermedia borders">
            <div class="boxHeader"><span class="orderName">מדיה</span></div>
            <div class="orderImages" v-for="image in $root.selectedOrderObj.Data.orderImg">
                <img :src="image" width="80px">
            </div>
        </div>
        

<!-- <span>{{ $root.selectedOrderObj.fullname }}</span> -->
    </div>
</template>
<!-- {{ $root.selectedOrderObj.Data.fullname }} -->
<script>
  import { db } from '../firebase';

  export default {
    name: 'SelectedOrder',
    orders : [],
    

    data () {
      return {
        editOrder: true,
      }
    },
    created (){
        let vm = this;
        console.log("Order Object is : ", vm.$root.selectedOrderObj)
        console.log("Order Id is : ", vm.$root.selectedOrderObj.ID)
    },
    methods : {
        deleteOrder(){
          let vm = this;
          console.log("Order Id is : ", vm.$root.selectedOrderObj.ID)
          let answer = confirm("האם אתה בטוח למחוק ההזמנה?" );
          
          if (answer){
            db.collection("orders").doc(vm.$root.selectedOrderObj.ID).delete().then(() => {
                console.log("Document successfully deleted!");
                vm.$router.push("/Home");
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });

          }
        },
        updateOrder(){
            let vm = this;
            let newStatus = vm.$root.selectedOrderObj.Data.status;
            db.collection("orders").doc(vm.$root.selectedOrderObj.ID).get()
            .then( (order) =>{
                let orderData = order.data();
                let i = vm.$root.selectedOrderIndex;
                orderData.status = newStatus;
                db.collection("orders").doc(vm.$root.selectedOrderObj.ID).update(orderData);
                console.log("New Status is :" + newStatus) ;
                alert("סטטוס ההזמנה עודכן בהצלחה")
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        },
        updateOrderData(){
            let vm = this;
            let newName = vm.$root.selectedOrderObj.Data.fullname;
            let newPhone = vm.$root.selectedOrderObj.Data.phoneNumber;
            let newdateOrder = vm.$root.selectedOrderObj.Data.dateOrder;
            let newdayOrder = vm.$root.selectedOrderObj.Data.dayOrder;
            let newtimeOrder = vm.$root.selectedOrderObj.Data.timeOrder;
            let newcakeTaste = vm.$root.selectedOrderObj.Data.cakeTaste;
            let newcakeSize = vm.$root.selectedOrderObj.Data.cakeSize;
            let newpriceOrder = vm.$root.selectedOrderObj.Data.priceOrder;
            db.collection("orders").doc(vm.$root.selectedOrderObj.ID).get()
            .then( (order) =>{
                let orderData = order.data();
                let i = vm.$root.selectedOrderIndex;
                orderData.fullname = newName;
                orderData.phoneNumber = newPhone;
                orderData.dateOrder = newdateOrder;
                orderData.dayOrder = newdayOrder;
                orderData.timeOrder = newtimeOrder;
                orderData.cakeTaste = newcakeTaste;
                orderData.cakeSize = newcakeSize;
                orderData.priceOrder = newpriceOrder;
                db.collection("orders").doc(vm.$root.selectedOrderObj.ID).update(orderData);
                console.log("Order Successhully Updated!" ) 
            // editOrder = !editOrder
            })
            .catch((error) =>{
                console.log("Error :" , error);
            })
        }

    }
}
</script>

<style>
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.selectedOrderContainer{
    padding: 1rem;
}
.orderBox{
    width: 500px;
    min-height: 500px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
}
.orderTitle{
    width: 100%;
    height: 70px;
    background-color: #fcfcfc;
    display: flex;
    align-items: center;
    position: relative;
}
.orderName{
    font-size: 18px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
}
.deleteBtn{
    position:absolute;
    left: 20px;
    background-color: #d32f2f;
    width: 30px;
    height: 30px;
    color: var(--light);
    border: none;
    font-size: 18px;
    border-radius: 8px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.deleteBtn span{
    line-height: 30px;
    font-size: 16px;
}
.editBtn {
    position: absolute;
    left: 55px;
    background-color: #e0e0e0;
    width: 30px;
    height: 30px;
    color: var(--grey);
    border: none;
    font-size: 18px;
    border-radius: 8px;
    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}
.editBtn span{
    line-height: 30px;
    font-size: 16px;
}
.status{
    background-color: transparent;
    width: 100%;
    height: 50px;
    padding: 1rem;
    display: flex;
    align-items: center;
    position: relative;
}
.status .liveStatus{
    float: right;
    font-size: 14px;
    color: #666;
    font-weight: 600;
    letter-spacing: 1px;
}
.changeData{
    position: absolute;
    left: 20px;
    top: 10px;
}
.changeData select{
    width: 100px;
    height: 30px;
    border: 1px solid #eee;
    font-size: 13px;
    color: #000;
    position: absolute;
    left: 32px;
}
.changeData .sendDataBtn{
    width: 30px;
    height: 30px;
    border: 0;
    background-color: #73e7cc;
    color: #003c47;
    position: absolute;
    left: 0px;
}
.sendDataBtn span{
    line-height:30px ;
    text-align: center;
    font-size: 14px;
}
.orderDetials{
    width: 100%;
    height: 100px;
    background-color: transparent;
    padding: 1rem;
}
.detailsBox{
    width: calc(100% / 2 - 5px);
    display: inline-block;
    background-color: #fcfcfc;
    height: 37px;
    vertical-align: top;
    line-height: 37px;
    margin-bottom: 10px;
}
.detailsBox > .material-icons{
    width: 40px;
    height: 37px;
    background-color: #eee;
    color: #666;
    font-size: 18px;
    vertical-align: top;
    line-height: 37px;
    text-align: center;
}
.detailsBox .text{
    text-align: left;
    padding-right: 5px;
    font-weight: 700;
    font-family: 'Noto Sans Hebrew', 'Noto Sans Arabic';
    font-size: 14px;
}
.orderId{
    background-color: transparent;
    width: 100%;
    margin-bottom: 5px;
    padding: 0  0.5rem;
    position: relative;
}
.orderEditBtn{
    position: absolute;
    left: 17px;
    top: 0;
    padding: 6px 37px;
    border: 0;
    font-size: 14px;
    border-radius: 8px;
    background-color: #00414d;
    color: #fff;
}
.orderZehot{
    font-size: 14px;
    font-weight: 800;
    font-family: 'Noto Sans Hebrew';
}
.orderIdStyle{
    color: var(--grey);
    font-size: 13px;
}
.borders{
    border: 1px solid #eee;
    border-radius: 8px;
}
.orderDataBox{
    width: 68%;
    min-height: 250px;
    background-color: #fff;
    margin:  5px;
    float: right;
}
.ordermedia{
    width: 30%;
    min-height: 250px;
    background-color: #fff;
    margin: 5px;
    float: right;
}
.boxHeader{
    background-color: yellow;
    width: 100%;
    height: 70px;
    background-color: #fcfcfc;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    position: relative;
}
.orderImages{
    padding: 1rem;
    text-align: center;
}
.orderImages img{
    width: 50%;
}
.orderInputField{
    width: 50%;
    float: right;
    padding: 10px 20px;
}
.orderInputField input{
    width: 100%;
    height: 37px;
    border-radius: 8px;
    border: 1px solid #eee;
    padding-right: 10px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Arabic','Noto Sans Hebrew';
}
.orderInputField select{
    width: 100%;
    height: 37px;
    border-radius: 8px;
    border: 1px solid #eee;
    padding-right: 10px;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Arabic','Noto Sans Hebrew';
}
.orderInputField label{
    font-size: 14px;
    font-family: 'Noto Sans Hebrew';
    font-weight: 700;
    padding-right: 5px;
}
.orderBtnField {
    padding: 20px;
    float: left;
}
.orderBtnField button{
    padding: 5px 10px;
    font-size: 14px;
    color: #003c47;
    background-color:#73e7cc ;
    border: 0;
    border-radius: 8px;
    font-weight: 500;
    height: 37px;
    width: 150px;
}
.selectedOrderPrice{
    position: absolute;
    left: 90px;
    background-color: #ffe186;
    width: 75px;
    height: 30px;
    color: var(--dark);
    border: none;
    font-size: 15px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
}
    @media only screen and (max-width:1180px) {
    .orderDataBox{
    width: 67%;
    min-height: 250px;
    background-color: #fff;
    margin:  5px;
    float: right;
    }
    .orderInputField input {
    width: 100%;
    }
}
    @media only screen and (max-width:430px) {
        
    .orderDataBox{
    width: 100%;
    }
    .ordermedia {
    width: 100%;
    }
    .orderInputField{
    width: 100%;
    float: right;
    padding: 5px 10px;
    }
    .orderInputField input {
    width: 100%;
    }
    .orderInputField select{
    width: 100%;
    }

}
</style>


// WEBPACK FOOTER //
// src/pages/SelectedOrder.vue